module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/7375d4404ecc319700095f07f1c5ad07.png";